import { StyleSheet } from 'aphrodite/no-important';
import { spacers, palettes, borderRadius } from '@trainline/depot-web/css';

export default StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px',
    padding: `${spacers.dp_s24} 122px`,
    display: 'flex',
    flexDirection: 'column',
  },
  fullWidth: {
    width: '100%',
    textAlign: 'center',
  },
  twoColumns: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacers.dp_s32,
    width: '100%',
    justifyContent: 'space-between',
  },
  column: {
    flex: '1 1 48%',
    boxSizing: 'border-box',
  },
  spacer: {
    margin: `${spacers.dp_s24} 0`,
  },
  cardsLayout: {
    borderRadius: borderRadius.dp_r12,
    border: `1px solid ${palettes.dp_app_border_base}`,
    padding: spacers.dp_s24,
    backgroundColor: palettes.dp_app_backdrop_base,
    minHeight: '300px',
    width: '100%',
    margin: `${spacers.dp_s24} 0`,
  },
  journeyDirection: {
    padding: `0 ${spacers.dp_s32}`,
    marginBottom: spacers.dp_s24,
  },
});
